import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { TranslatorService } from 'src/app/services/translator-service/translator.service';
import { parse, isValid, differenceInYears } from 'date-fns';

//Camel Case splitter for front end usage
@Pipe({
  name: 'camelCaseSplit',
  standalone: false
})
export class CamelCasePipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(camelCase: any): string {
    const newCamelCase = String(camelCase);
    let ccSplit = newCamelCase.split(/(?=[A-Z])/).join(' ');
    if (ccSplit == undefined) {
      ccSplit = '';
    }
    return ccSplit;
  }
}

export interface EnumValueModel {
  key: string;
  value: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  enumVal: any;
}


export class EnumHelper {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static getTextAndValue(type: any, typeName?: string, translator?: TranslatorService, sort: boolean = true): EnumValueModel[] {
    const result: EnumValueModel[] = [];

    const vals = Object.values(type);

    for (let x = 0; x < vals.length; x++) {
      const sSource = vals[x] as string;
      let sValue = sSource;

      if (!translator || !typeName) {
        sValue = this.splitCamelCase(sSource);
        sValue = sValue.charAt(0).toUpperCase() + sValue.slice(1);
      } else {
        const enumpath = 'enum-helper.enum.' + typeName.toLocaleLowerCase() + '.' + sSource.toLocaleLowerCase();
        sValue = translator.translateText(enumpath);
      }

      result.push({
        key: sSource,
        value: sValue,
        enumVal: vals[x]
      });
    }
    
    if(sort){
      // Sort the result array alphabetically by the value property
      result.sort((a, b) => a.value.localeCompare(b.value));
    }
    return result;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static getEnumFromInt(type: any, intVal: number): any {
    const vals = Object.values(type);
    if (vals.length > intVal)
      return vals[intVal];
    return undefined;
  }

  public static splitCamelCase(newCamelCase: string): string {
    let ccSplit = newCamelCase.split(/(?=[A-Z])/).join(' ');
    if (ccSplit == undefined) {
      ccSplit = '';
    }
    return ccSplit;
  }
}



export function minimumAgeValidator(minimumAge: number, isUSFormat: boolean): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const inputValue = control.value;
    if (!inputValue) return null;

    let format: string;

    if (inputValue.includes('-')) {
      format = 'yyyy-MM-dd'; // Assume ISO
    } else if (inputValue.includes('/')) {
      format = isUSFormat ? 'MM/dd/yyyy' : 'yyyy/MM/dd';
    } else {
      return { invalidDate: { value: control.value, reason: 'Unrecognized format' } };
    }

    const birthDate = parse(inputValue, format, new Date());


    if (!isValid(birthDate)) {
      return { invalidDate: { value: control.value } };
    }

    const age = differenceInYears(new Date(), birthDate);
    const isOldEnough = age >= minimumAge;


    return isOldEnough ? null : { minimumAge: { value: control.value } };
  };
}